import { collectionKind } from "./db-collection-kind";
import { CollectionLocation } from "./db-collection-location";
import { CollectionType } from "./db-collection-type";

export class CollectionRequest {
  id?: number | null = null;
  name: string | null = null;
  description: string | null = null;
  type: CollectionType | null = null;
  location?: CollectionLocation | null = null;
  kind?: collectionKind | null = null;
  targetGroupIds: number[] | null = null;
  targetUserIds: number[] | null = null;
  objectIds: number[] | null = null;
  randomDisplay: boolean | null = false;
  isPublished: boolean | null = false;

  constructor(init?: Partial<CollectionRequest>) {
    Object.assign(this, init);
  }
}
